<template>
  <el-aside :collapse="isCollapse"
            class="showbutton"
            width='170px'
            style="float:left;">
    <el-menu router
             :default-active="$route.path"
             unique-opened>
      <template v-for="(Pitem,Pindex) in menuInfo"
                v-if="Pitem.path === parentPath">
        <el-submenu :index="Pindex+''"
                    :key="Pindex+''">
          <template slot="title">
            <img class="title-icon"
                 :src="Pitem.icon"
                 alt="">
            {{Pitem.name}}
          </template>
          <el-menu-item-group v-for="item of Pitem.children"
                              :key="item.path">
            <el-menu-item @click="refresh(item)"
                          :key="item.path"
                          :index="Pitem.path+'/'+item.path">
              {{item.name}}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import { menu } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'HomeAside',
  data () {
    return {
      isCollapse: true,
      headerNav: 'navSys',
      parentPath: '',
      menuInfo: []
    }
  },
  //   computed: mapState({
  //     menuInfo: state => state.menu.menuInfo
  //   }),
  watch: {
    $route (to, from) {
      let parentPath = to.matched[1].path
      this.parentPath = parentPath
    }
  },
  mounted () {
    let parentPath = this.$route.matched[1].path
    this.parentPath = parentPath
    this.getMenu()
    // console.log('aaa', this.parentPath)
  },
  methods: {
    refresh (router) {
      // console.log('item', router.path)
      // let path = router.path
      // this.$router.push({ path: '/manage/' + router.path })
      // // window.location.reload()
      // console.log('adsad', this.$route.path)
      // let getRoutePath = ''
      // getRoutePath = this.$route.path
      // // console.log(getRoutePath)
      // if (getRoutePath === '/manage/' + router.path | getRoutePath === '/system/' + router.path) {
      //   console.log('aaa')
      // }
      // console.log(routePath)

      // if (this.$route.path.split('/manage/')[1] === router.path) {
      //   location.reload()
      // }
      // console.log(router.path)
      // location.reload('/manage/' + router.path)
    },
    getMenu () { // 获取侧边栏信息
      this.menuInfo = JSON.parse(localStorage.getItem('menulist'))
      // console.log(this.menuInfo)
      if (this.menuInfo) {
        this.menuInfo.forEach(element => {
          if (element.path === '/system') {
            this.$store.commit('menuInfo/showSystem', true)
          }
        })
      } else {
        menu().then(res => {
          if (res.data.code === 200) {
            this.menuInfo = res.data.data
            // console.log(this.menuInfo)
            this.menuInfo.forEach(element => {
              if (element.path === '/system') {
                this.$store.commit('menuInfo/showSystem', true)
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="stylus" >
@import '~styles/varibles.styl'
.border-bottom
  &:before
    border-color #ccc
.el-aside
  width 170px
  position absolute
  top 52px
  background #fff
  bottom 0
  border-right 1px solid #e6e6e6
  box-shadow 0px 0px 12px rgba(27, 136, 238, 0.3)
  z-index 100
  .el-menu
    border-right none
  .el-submenu
    .el-menu-item, .el-submenu__title
      height 50px
      line-height 50px
    .el-menu-item-group__title
      padding 0
    .el-menu-item-group
      .el-menu-item
        background #f7f9fb
        .ic-point
          width 4px
          height 4px
          background #eee
          float left
          margin-top 21px
          margin-right 5px
          font-size 12px !important
          border-radius 50%
          border 2px solid rgba(173, 180, 190, 0.4)
      .el-menu-item:hover
        .ic-point
          background rgba(27, 136, 238, 0.8)
          border 2px solid rgba(27, 136, 238, 0.4)
      .el-menu-item.is-active
        .ic-point
          background rgba(27, 136, 238, 0.8)
          border 2px solid rgba(27, 136, 238, 0.4)
  .el-submenu__title
    padding-left 14px !important
    border-bottom 1px solid #ccc !important
    font-size 12px
    .title-icon
      font-size 16px
      color $bgColor
      padding-right 9px
  .el-submenu__title:focus, .el-submenu__title:hover, .el-menu-item:focus, .el-menu-item:hover
    outline 0
    color $bgColor
    background none
  .el-menu-item.is-active
    color #1b88ee
    background #e6fefe !important
  .el-submenu .el-menu-item
    min-width auto
    font-size 12px
</style>
